// extracted by mini-css-extract-plugin
export default {"projectBox":"VolunteerBlock_projectBox__skL0W","pix":"VolunteerBlock_pix__xsuFp","description":"VolunteerBlock_description__izXc2"};